<template>
    <div class="p-4">
        <checkout-offer />
        <div class="p-4 py-5">
            <h4 class="animation">
                <pre>You're all set</pre>
            </h4>
            <div class="animation">
                Next step is to download and install the Ladder app on your
                iPhone and login with the email
                <b v-if="shared.user">{{ shared.user.account.email }}</b> and
                the password you used during sign up.
            </div>
            <div class="animation mt-5">
                <v-button
                    aria-label="Ladder iOS App"
                    href="https://apps.apple.com/us/app/ladder-your-personal-trainer/id1208138698?mt=8"
                    size="lg"
                    variant="dark"
                >
                    <fa-icon :icon="['fab', 'apple']" class="mr-3" />Download
                    Ladder
                </v-button>
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/store.js";
import anime from "animejs/lib/anime.es.js";
import CheckoutOffer from "@/components/CheckoutOffer";

export default {
    name: "CheckoutSuccess",
    components: {
        CheckoutOffer
    },
    data() {
        return {
            shared: store.state
        };
    },
    mounted() {
        anime.timeline({ loop: false }).add({
            targets: ".animation",
            opacity: [0, 1],
            translateZ: [0],
            translateY: [40, 0],
            duration: 600,
            delay: anime.stagger(300),
            easing: "easeOutQuad"
        });
    }
};
</script>
